"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _FreeformQuickReply = _interopRequireDefault(require("../inputs/FreeformQuickReply"));

var _EditPropertyQuickReplyInput = _interopRequireDefault(require("../inputs/EditPropertyQuickReplyInput"));

var _QuestionEntityRecord = _interopRequireDefault(require("../QuestionEntityRecord"));

var _QuestionTextInput = _interopRequireDefault(require("../inputs/QuestionTextInput"));

var _QuestionTypeInput = _interopRequireDefault(require("../inputs/QuestionTypeInput"));

var QuestionAndAnswerForm = function QuestionAndAnswerForm(_ref) {
  var properties = _ref.properties,
      question = _ref.question,
      onChange = _ref.onChange;
  return _react.default.createElement("div", null, _react.default.createElement(_QuestionTextInput.default, {
    question: question,
    onChange: onChange
  }), _react.default.createElement(_QuestionTypeInput.default, {
    question: question,
    onChange: onChange
  }), _react.default.createElement(_FreeformQuickReply.default, {
    question: question,
    onChange: onChange
  }), _react.default.createElement(_EditPropertyQuickReplyInput.default, {
    question: question,
    properties: properties,
    onChange: onChange
  }));
};

QuestionAndAnswerForm.propTypes = {
  properties: _propTypes.default.instanceOf(_immutable.Map).isRequired,
  question: _propTypes.default.instanceOf(_QuestionEntityRecord.default).isRequired,
  onChange: _propTypes.default.func.isRequired
};
var _default = QuestionAndAnswerForm;
exports.default = _default;
module.exports = exports.default;